import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/management/add.svg'


const _hoisted_1 = { class: "hasAdminButtonsFooter" }
const _hoisted_2 = {
  key: 1,
  class: "adminButtonContainer"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_post = _resolveComponent("post")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.posts.length == 0)
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 0,
          localizedKey: "app_ancoranientealmomento",
          text: "Ancora niente al momento",
          class: "fs_14 greyBlue d-block ln_12 mt-5 text-center"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.posts, (item, i) => {
      return (_openBlock(), _createBlock(_component_post, {
        class: "mb-3",
        key: item.identifier,
        ref: item.identifier,
        post: item,
        "community-identifier": _ctx.$store.state.community.identifier,
        onRemoved: ($event: any) => (_ctx.onRemoved($event, i)),
        "can-content": _ctx.$store.state.community.canContent,
        showCommunityTitle: _ctx.isFiera
      }, null, 8, ["post", "community-identifier", "onRemoved", "can-content", "showCommunityTitle"]))
    }), 128)),
    (_ctx.$store.state.community.canContent && !_ctx.isFiera)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", {
            class: "managementButton",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newPost()))
          }, [
            _hoisted_3
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}